import { TRight } from "./Config";
import { BaseRoute } from "./BaseRoute";
import { IAuth } from "../AuthContext";

class SecureRoute extends BaseRoute {
  public right: TRight;

  constructor(right: TRight, path: string, title: string, component: any) {
    super(path, title, component);
    this.right = right;
  }

  public isAllowed = (auth: IAuth): boolean => {
    // console.log("isAllowed", auth);
    if(this.right == null) return true;
    return auth.hasRight(this.right);
  }  
}

export { SecureRoute }
